import Glider from 'glider-js';
import { isServer } from '.';

export const createGliderContainer = (element: HTMLElement) => {
  if (isServer()) {
    return null;
  }

  return new Glider(element, {
    slidesToShow: 1.075,
    slidesToScroll: 1,
    draggable: true,
    dots: '.dots',
    arrows: {
      prev: '.glider-prev',
      next: '.glider-next',
    },
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2.25,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          draggable: false,
          itemWidth: 350,
          exactWidth: true,
          slidesToShow: 'auto',
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 2048,
        settings: {
          draggable: false,
          itemWidth: 350,
          exactWidth: true,
          slidesToShow: 'auto',
          slidesToScroll: 4,
        },
      },
    ],
  });
};
